module.exports = __webpack_public_path__ + "img/2025-07-21b_1.f66c1ee4.jpg";